import styled from "styled-components";
import { CSSProperties } from "react";

export const formStyle: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  border: "3px solid black",
  margin: "15px",
  background: "#f0f4f7",
  borderRadius: "10px",
};

export const layout = {
  //Layout que altera o tamanho e a posição dos nomes e labels dos formulários de : Empreendimentos,Especificações de Apto,Cadastrar Apartamento,AtualizarCadastro,CadastroProprietario
  labelCol: { span: 10 },
  wrapperCol: { span: 10 },
};
export const layoutAp = {
  //Layout que altera o tamanho e a posição dos nomes e labels do formulário: Mais Info do Apartamento
  labelCol: { span: 16 },
  wrapperCol: { span: 8 },
};

export const btnStyle: CSSProperties = {
  marginTop: 20,
  borderWidth: "3px",
  borderRadius: "12px",
  backgroundColor: "rgb(0, 54, 68)",
  color: "#FFFFFF",
};

export const Container = styled.section`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  // Para garantir que o layout seja responsivo
  @media (max-width: 768px) {
    flex-direction: column; /* Empilhamento vertical em telas menores */
  }

  & > :first-child {
    flex: 0 0 10%; /* 10% para o topo */
  }

  & > :last-child {
    flex: 1; /* 90% para o conteúdo restante */
  }
`;
export const ContainerTitulo = styled.section`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template: 100% / 1.6% 90%;
  justify-content: center;
  align-items: center;
`;
export const ContainerFiltro = styled.section`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template: 100% / 70% 95%;

  justify-content: center;
  align-items: center;
`;
export const ContainerSeta = styled.div`
  width: 100%;
  height: 100%;

  grid-column-start: 1;
  grid-row-start: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const ContainerLista = styled.section`
  width: 100%;
  height: 100%;
  display: grid;
  min-width: 20rem;
  overflow: auto;
  padding: 1rem;

  grid-template: 10% 90% / auto;
`;

export const BotoesAcoes = styled.button`
  border: none;
  color: blue;
  background-color: transparent;
  &: hover {
    cursor: pointer;
  }
`;

export const ContainerUsuario = styled.div`
  width: 90%;
  height: auto;
  margin-top: 8px;
  border: 2px solid #000000;
  background: #f1f1f1;
  border-radius: 8px;
`;
export const Title = styled.h1`
  font-size: 25px;
  font-weight: bold;
  color: #003644;
  margin-top: 15px;
  margin-left: 15px;
`;
export const SubTitleUsuario = styled.h2`
  font-size: 18px;
  font-weight: bold;
  color: #003644;
  margin-top: 15px;
  margin-left: 15px;
`;
export const TextUsuario = styled.p`
  font-size: 16px;
  color: #20231c;
  margin-left: 15px;
`;
export const ContainerModalBtn = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
`;
export const ContainerModal = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ItemTextModal = styled.p`
  font-size: 16px;
  font-weight: 600;
  color: #4a4a4a;
`;

export const TextModal = styled.p`
  font-size: 16px;
  color: #6d6d6d;
  font-weight: 500;
`;
